import { IApiResponse } from "@/interface";
import { axios } from "@/lib/axios"
import { TUser } from "../types";

export const createUser = (data: TUser): Promise<IApiResponse> => {
  const toSend = {
    ...data,
  };
  return axios.post("/accounts", toSend);
};

export const updateUser = (id: string, data: TUser): Promise<IApiResponse> => {
  const toSend = {
    ...data,
  };
  return axios.put("/accounts/" + id, toSend);
};

export const getAllUsers = (): Promise<IApiResponse> => {
  return axios.get("/accounts");
};

export const deletedUser = (idUser: string): Promise<IApiResponse> => {
  return axios.delete("/accounts/" + idUser);
};

export const updateStatutUser = (idUser: string, data: any): Promise<IApiResponse> => {
  return axios.put("/update-statut/" + idUser, data);
};

export const getAllUsersLogs = (page?: number, limit?: number, search?: string): Promise<IApiResponse> => {
  return axios.get("/users-logs", { params: { page, limit, search } });
};



// Les API des profils d'utlisateurs 
export const getProfils = (): Promise<IApiResponse> => {
  return axios.get("/profil");
};